import { useMutation } from 'react-query';

import { CROSSING_DIRECTION_COUNTRY } from '@/features/shared/constants';
import { axios } from '@/lib/axios';

type CreateFolderType = {
  folderTypologyId: string;
  direction: CROSSING_DIRECTION_COUNTRY;
};

const carrierId = 'B112831C-A0D4-11EE-8C90-0242AC120002';
const borderCrossingServiceId = '11A27116-A0D4-11EE-8C90-0242AC120002';

const createFolderByTypologyAsync = (createFolderData: CreateFolderType) =>
  axios.post<string>('/folders', { ...createFolderData, carrierId, borderCrossingServiceId });

export const useCreateFolderByTypologyAsync = () =>
  useMutation({
    mutationFn: createFolderByTypologyAsync,
  });
